<template>
  <TableTemplate
    v-model="tableResult"

    :columns="websiteColumns"
    :columnVariables="websiteColumnVariables"
    :capitalize="capitalize"
    :skeletonClass="skeletonClass"

    :page="page"
    :enable-sorting="true"

    @update-column-order="updateColumnOrder"
    @set-page="v => page = v"
    
    :max="max"

    ref="table"
  >
    <template #cell-is_global="{value, item}">
      <FormToggleSwitch v-model="value" @click.native="updateSettingType(item, value)"/>
      <span class="ml-2">
        Is global settings
      </span>  
    </template>
    <template #cell-name="nameProps">
      <slot name="name" v-bind="nameProps" :refetch="refetch">
        <span class="pointer" @click="editSupplier(nameProps.item)">{{ nameProps.value }}</span>
      </slot>
    </template>
    <template #above>
      <TableHeader
        title="Product settings"
        :alwaysShowMultiSelectCheckbox="true"
        :removeColumnConfiguration="true"
        :refetch="refetch"
        :exportParams="exportEndpointParams"

        @customize-layout="customizeLayout"
      >
        <template #header-buttons-before="props">
          <slot name="header-buttons-before" v-bind="props"></slot>
        </template>
        <template #after-title>
          <HeaderButton class="ml-2"
            buttonTypeClass="btn-outline-primary btn-primary-secondary-outline"
            style="padding: 11px 8px"
            @click.native="addSupplier"
          >
            Create setting
          </HeaderButton>
        </template>
      </TableHeader>

      <div class="d-flex">
        <TableMainSearchField v-model="search"/>
        <RefreshBtn
          :loading="isLoadingTableResult"
          @click.native="refresh"
        />
      </div>
    </template>
  
    <template v-if="loaded" #row-action="{item}">
      <div class="delete-icon" @click="confirmDelete(item)">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
        </svg>
      </div>
    </template>

    <template #empty-state>
      <EmptyStatePlaceholder
        title="Er zijn geen leveranciers"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
          <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z" />
        </svg>
      </EmptyStatePlaceholder>
    </template>
  </TableTemplate>
</template>

<script>

import TableTemplate from 'src/layout/Table/TableTemplate'
import tableFieldOptions from "src/mixins/tableFieldOptions"
import TableSearchField from "src/components/Inputs/TableSearchField.vue"
import TableActionDropdown from "src/components/Inputs/TableActionDropdown.vue"
import EmptyStatePlaceholder from "src/layout/EmptyStatePlaceholder.vue"
import HeaderButton from "src/components/Inputs/HeaderButton.vue"
import TableHeader from "src/components/Product/ProductTable/TableHeader.vue"
import TableMainSearchField from '../layout/TableMainSearchField.vue'
import RefreshBtn from '../layout/RefreshBtn.vue'

import TableCell from "src/components/Table/TableCell.vue"

import table from "src/mixins/table"

import FormToggleSwitch from "@/components/Inputs/FormToggleSwitch";

export default {
  metaInfo: {
    title: "Leveranciers",
  },
  components: {
    TableCell,
    TableMainSearchField,
    TableTemplate,
    TableSearchField,
    RefreshBtn,
    TableActionDropdown,
    TableHeader,
    EmptyStatePlaceholder,
    HeaderButton,
    FormToggleSwitch,
  },
  mixins: [
    tableFieldOptions,
    table({
      pageReference: 'product-settings',
      
      params: {
        name: "",
        sku: null,
        price: 0,
        website: "",
        search: "",
      },
      route: "/api/products/settings",
    }),
  ],
  methods: {
    addSupplier() {
      this.$pushModal({
        modal: "EditSupplierProductSetting",
        toBind: {
          callback: this.freshRefetch,
        },
      })
    },
    editSupplier(supplier) {
      this.$pushModal({
        modal: "EditSupplierProductSetting",
        toBind: {
          supplier: this.tableResult.find(item => item.uid === supplier.uid),
          callback: this.freshRefetch,
        },
      })
    },
    async deleteSetting(uid) {
      await this.$handlePromise(
        this.axios.delete(`/api/products/settings/${uid}`)
      )
      this.$success("Productgroup succesvol verwijderd!")
      this.freshRefetch()
    },
    confirmDelete(item) {
      this.$confirmAction(
        () => this.deleteSetting(item.uid),
        {
          title: "Product setting verwijderen",
          description: `Are you sure you want to delete the <b>${item.name}</b> product group?`,
          buttonSave: "Verwijderen",
        }
      )
    },
    async updateSettingType(item, value) {
      const { uid, name } = item;
      await this.updateSingleTableRowById(uid, { name, is_global: value  });
    }
  },
  computed: {
    table() {
      return this.$refs.table
    },
    websiteColumns() {
      return ['Name', 'Type', 'Fields']
    },
    websiteColumnVariables() {
      return ['name', 'is_global', 'fields']
    },
    capitalize() {
      return [false]
    },
  }
}

</script>
<style>
.pointer {
  cursor: pointer;
}
</style>